module.exports = __webpack_public_path__ + "static/img/home_cpjfw_qyjjfa.f7a7bd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_cpjfw_qyjjfa.png
// module id = M9hI
// module chunks = 21